import React from 'react';
import classnames from 'classnames';
import styles from './styles.mod.scss';

export default function ProgressBar({ percentage, color, className }) {
  let style = { width: `${percentage}%` };
  if (color) style.backgroundColor = color;
  if (percentage > 0) style.minWidth = '1rem';

  return (
    <div className={classnames(styles.background, className)}>
      <div className={styles.progressBar} style={style} />
    </div>
  );
}
